import React from 'react';
import {
  CreatePublicProfileParams,
  useCreatePublicProfile,
  useGetPublicProfiles,
} from 'data/v3/publicProfiles';
import ReviewProfileSearch from './ReviewProfileSearch';
import toast from 'helpers/toast';
import styled from 'styled-components';
import { Text } from '@companycam/slab-web';
import { translate } from 'javascripts/translations/i18n';
import { useProfileForm } from 'components/publicProfile/useProfileForm';

const StyledReviewProfileSearch = styled(ReviewProfileSearch)`
  margin-top: var(--cc_size_spacing_s);
`;

const Container = styled.div`
  background-color: var(--cc_color_background_1);
  width: 100%;
  max-width: 600px;
  padding: var(--cc_size_spacing_xxl);
  border-radius: var(--cc_size_border_radius_xl);
  border: 1px solid var(--cc_color_border_default);
  box-shadow: 0 2px 12px var(--cc_color_depth_1);
`;

const ReviewProfileManager = ({
  onSuccess,
  className,
}: {
  onSuccess?: () => void;
  className?: string;
}) => {
  const {
    data: publicProfileResponse,
    isLoading,
    refetch,
  } = useGetPublicProfiles();
  const publicProfile = publicProfileResponse?.data[0] || null;
  const formMethods = useProfileForm({
    mode: 'onChange',
  });
  const createPublicProfile = useCreatePublicProfile({
    onError() {
      refetch();
      toast.error(translate('project.reviews.reviewProfile.googleLinkError'));
    },
    onSuccess() {
      toast.success(
        translate('project.reviews.reviewProfile.googleLinkSuccess'),
      );
      onSuccess?.();
    },
  });

  const handleConfirm = formMethods.handleSubmit(
    (data: CreatePublicProfileParams) => {
      createPublicProfile.mutate(data);
    },
  );

  if (isLoading) {
    return null;
  }

  return (
    <Container className={className}>
      <Text as="h2" size="xl" ccMargin="none none m none">
        {translate('project.reviews.reviewProfile.title')}
      </Text>
      {publicProfile ? null : (
        <StyledReviewProfileSearch
          onCancel={() => {}}
          onConfirm={handleConfirm}
          formMethods={formMethods}
        />
      )}
    </Container>
  );
};

export default ReviewProfileManager;
